import {IoChevronBack, IoChevronForward} from 'react-icons/io5';

import styled from 'styled-components';

interface DayProps {
  active?: boolean;
  hover?: boolean;
}

interface ColumnProps {
  hover?: boolean;
  isDay?: number;
}

interface HoverProps {
  hover?: boolean;
  start?: boolean;
  end?: boolean;
}

interface ConfirmProps {
  active: boolean;
}

export const Container = styled.div`
  padding: 15px;
  border-radius: 8px;
  width: fit-content;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.white};
`;

export const Table = styled.table`
  font-size: 12px;
  border-collapse: collapse;
  width: 100%;
`;

export const TableHeader = styled.thead``;

export const HeaderRow = styled.tr``;

export const HeaderColumn = styled.td`
  text-align: center;
  padding-bottom: 5px;
  border: 2px solid ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.darkGray};
  font-weight: 500;
`;

export const TableBody = styled.tbody``;

export const Row = styled.tr``;

export const Column = styled.td<ColumnProps>`
  position: relative;
  cursor: pointer;

  &:hover div {
    border-color: ${(props) =>
      props.isDay ? props.theme.colors.primary : props.theme.colors.white};
  }
`;

export const Day = styled.div<DayProps>`
  position: relative;
  border-spacing: 2px;
  border: 2px solid
    ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.transparent};
  width: 32px;
  height: 32px;
  margin-left: 5px;
  border-radius: 50%;
  color: ${(props) =>
    props.active ? props.theme.colors.white : props.theme.colors.darkGray};
  background-color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.transparent};
  ${(props) =>
    props.hover &&
    !props.active &&
    `background-color: ${props.theme.colors.white} !important`};
  cursor: pointer;
  z-index: 1000;
  font-weight: 500;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Empty = styled.td`
  width: 30px;
  height: 30px;
  position: relative;
`;

export const Hover = styled.div<HoverProps>`
  z-index: 1;
  position: absolute;
  left: ${(props) => (props.start ? '50%' : 0)};
  right: ${(props) => (props.end ? '50%' : 0)};
  top: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.colors.primaryLight};
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const PrevMonth = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  transition: all 0.1s ease-in-out;
  border-radius: 2px;

  &:hover {
    background-color: ${(props) => props.theme.colors.lightGray};
    transition: all 0.1s ease-in-out;
  }
`;

export const NextMonth = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  transition: all 0.1s ease-in-out;
  border-radius: 2px;

  &:hover {
    background-color: ${(props) => props.theme.colors.lightGray};
    transition: all 0.1s ease-in-out;
  }
`;

export const Month = styled.h3`
  color: ${(props) => props.theme.colors.primary};
  text-transform: capitalize;
`;

export const PrevIcon = styled(IoChevronBack)`
  background-color: ${(props) => props.theme.colors.transparent};
`;

export const NextIcon = styled(IoChevronForward)`
  background-color: ${(props) => props.theme.colors.transparent};
`;

export const DateInputs = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
`;

export const Input = styled.div`
  flex: 1;
  background-color: ${(props) => props.theme.colors.softGray};
  color: ${(props) => props.theme.colors.gray};
  padding: 10px 0;
  border-radius: 5px;
  text-align: center;
  text-transform: capitalize;
`;

export const Footer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
  justify-content: flex-end;
`;

export const Confirm = styled.div<ConfirmProps>`
  padding: 5px;
  color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.lightGray};
  transition: all ease-in-out 0.2s;
  border-radius: 5px;

  &:hover {
    color: ${(props) => props.active && props.theme.colors.primary};
    transition: all ease-in-out 0.2s;
    background-color: ${(props) =>
      props.active && props.theme.colors.primaryLight};
  }
`;
